import { render } from "./ArtistCard.vue?vue&type=template&id=065ea483&scoped=true&ts=true"
import script from "./ArtistCard.vue?vue&type=script&lang=ts"
export * from "./ArtistCard.vue?vue&type=script&lang=ts"

import "./ArtistCard.vue?vue&type=style&index=0&id=065ea483&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065ea483"]])

export default __exports__